export default __webpack_public_path__ + "static/media/12.b531c99e.pdf";